/* Contains all the routes of the application */
import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../common/pages/Login";
import PreLogin from "../common/pages/PreLogin";
import SigninOidc from "../oidc-client/SigninOidc";
import SignoutOidc from "../oidc-client/SignoutOidc";
import SilentSigninOidc from "../oidc-client/silentSigninOidc";
import LoadingView from "../common/pages/LoadingScreen";
import AppRoute from "../route";
import { useAppSelector } from "../common/hooks/redux-hooks";
import { AppState } from "../store";
import AppLayout from "../common/pages/AppLayout";

const AppRoutes: React.FC = () => {

  const authentication: any = useAppSelector(
    (state: AppState) => state.authReducer?.authentication
  );
  if (authentication?.user) {
    document.cookie = "id_Token=token";
    return <AppLayout></AppLayout>;
  } else {
    return (
      <>
        <Suspense fallback={<LoadingView />}>
          <Routes>
            <Route path={AppRoute.LOGIN} element={<Login />} />
            <Route path={AppRoute.SIGNIN_OIDC} element={<SigninOidc />} />
            <Route
              path={AppRoute.SILENT_SIGNIN_OIDC}
              element={<SilentSigninOidc />}
            />
            <Route
              path={AppRoute.SIGNOUT_CALLBACK_OIDC}
              element={<SignoutOidc />}
            />
            <Route path="*" element={<PreLogin />} />            
          </Routes>
        </Suspense>
      </>
    );
  }
};

export default AppRoutes;